var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { BrowserSupportService } from '../utils/browser-support.service';
import { isRtl } from '../utils';
/**
 * @hidden
 */
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.divStyle = {};
        _this.element = null;
        _this.footerWrap = null;
        _this.table = null;
        return _this;
    }
    Footer.prototype.componentDidMount = function () {
        this.setState({});
        var scrollbarWidth = (new BrowserSupportService()).scrollbarWidth;
        var rtl = isRtl(this.element);
        var padding = scrollbarWidth + 'px';
        var right = rtl ? 0 : padding;
        var left = rtl ? padding : 0;
        this.divStyle = { padding: "0 " + right + " 0 " + left };
    };
    /**
     *
     * @param scrollLeft - Scrolls to the left (in pixels).
     */
    Footer.prototype.setScrollLeft = function (scrollLeft) {
        if (this.footerWrap) {
            this.footerWrap.scrollLeft = scrollLeft;
        }
    };
    /**
     *
     * @param width - Scrolls the width (in pixels).
     */
    Footer.prototype.setWidth = function (width) {
        if (this.table) {
            this.table.style.width = width + 'px';
        }
    };
    Footer.prototype.render = function () {
        var _this = this;
        if (!this.props.staticHeaders) {
            return (React.createElement("tfoot", { className: "k-grid-footer" }, this.props.row));
        }
        return (React.createElement("div", { ref: function (div) { _this.element = div; }, className: "k-grid-footer", style: this.divStyle },
            React.createElement("div", { ref: function (div) { _this.footerWrap = div; }, className: "k-grid-footer-wrap" },
                React.createElement("table", { ref: function (table) { _this.table = table; } },
                    React.createElement("colgroup", { ref: function (e) { _this.props.columnResize.colGroupFooter = e; } }, this.props.cols),
                    React.createElement("tfoot", null, this.props.row)))));
    };
    return Footer;
}(React.Component));
export { Footer };
//# sourceMappingURL=Footer.js.map